import type { ReactNode } from 'react';
import { Fade, useMediaQuery } from '@mui/material';

interface NavMotionProps {
  children: ReactNode;
}

// @nexvia-logistics/ui has no Fade/transition equivalent — MUI's Fade (react-transition-group
// under the hood) is kept intentionally, same reasoning as mui-tel-input in docs/PENDING-
// FINDINGS.md finding #24: no better replacement exists, so the dependency stays.
export default function NavMotion({ children }: NavMotionProps) {
  // Respects the OS/browser reduced-motion setting, same as any other transition should —
  // and lets Playwright's `reducedMotion: 'reduce'` context option (playwright.config.js)
  // make this transition instant during e2e screenshots. Before this, `preparePageForScreenshot`
  // forcing `transition-duration: 0` via CSS did not reliably stop react-transition-group's
  // own JS timer (the `timeout` prop below) from leaving the DOM in an intermediate inline
  // style for a frame Playwright could still capture as "stable" (docs/PENDING-FINDINGS.md
  // finding #51/#53).
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  return (
    <Fade in timeout={prefersReducedMotion ? 0 : 400}>
      <div className="size-full">{children}</div>
    </Fade>
  );
}
